import { createFileRoute } from "@tanstack/react-router";
import ContactEs from "@/pages/es/ContactEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/contactus`;

export const Route = createFileRoute("/es/contactus")({
  head: () => ({
    meta: [
      { title: "Contáctenos | Neuro Wellness TMS Centers of America" },
      {
        name: "description",
        content:
          "Contacte a Neuro Wellness TMS Centers of America en Coral Springs, FL. Llame al (954) 827-9793 o envíe un mensaje para programar su consulta gratuita.",
      },
      { property: "og:title", content: "Contáctenos | Neuro Wellness TMS" },
      {
        property: "og:description",
        content:
          "Programe una consulta gratuita en Coral Springs, FL. Llame al (954) 827-9793.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Contáctenos | Neuro Wellness TMS" },
      {
        name: "twitter:description",
        content:
          "Programe una consulta gratuita en Coral Springs, FL. Llame al (954) 827-9793.",
      },
    ],
    links: [{ rel: "canonical", href: ES_URL }, ...buildHreflang("/contactus")],
  }),
  component: () => <ContactEs />,
});
